import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-incrementdetails-form',
  templateUrl: './incrementdetails-form.component.html',
  styleUrls: ['./incrementdetails-form.component.css']
})
export class IncrementdetailsFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/serviceregister/incrementdetails/incrementdetails-form/incrementdetails-form.component.ts